<template>
  <v-footer  color="#FFF" >
    <v-row
      :align="alignment"
      :justify="justify"
      class="lighten-5"
    >
      <v-col>
        <div class="foot_font">Copyright © 2020 etoak.com. All Rights Reserved V 1.8.5</div>
        <div class="foot_font">鲁ICP备16042106号</div>
      </v-col>

    </v-row>
  </v-footer>
</template>
<style>
  .foot_font {
    font-family: 'Roboto,sans-serif';
    font-weight: 400;
    font-style: normal;
    color: #CCCCCC;
    line-height: 24px;
    font-size: 14px;
    text-align: center;
  }
</style>
<script>
  export default {
    name: 'account-footer',
    data() {
      return {
        alignment: 'center',
        justify: 'center',
        absolute: false
      }
    }
  }
</script>
